/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Main } from '../AdminTeamCreation/styles';
import ActivityCategory from './activityCategories';
import BehaviorCategory from './behaviorCategories';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchChallengeTypeCount, fetWellbeingCategories } from '../../redux/actions';
import _ from 'lodash';
import Waiting from '../Waiting';
import {TabBottomLine, TabWrapper, BorderBottom, Heading} from '../RecogntionAdmin/styles'
import { BrandingTabContainer, BrandingTab } from '../common/commonStyles';
import {AdminCategories, AddIconBranding} from '../../utils/icons'
import HoverButton from '../common/HoverButton'
import ChallengeSnapShotDriver from "../ChallengeCreationAdmin/Driver/ChallengeSnapShotDriver";
import RecommendedCard from '../CompanyChallengesAdminUpdated/recommendedCard'
import { http } from '../../redux/http';
import { GetFeaturedChallengesLibrary } from '../../redux/constants/apiConstants';
import { toast } from "react-toastify";

class ChallengesCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabId: 1,
      selectedTab: this.props.history.location && this.props.history.location.query && this.props.history.location.query.isCategory ? 2 : 1,
      hoverButton: false,
      getFeaturedChallenge:[]
      //showWalkthrough: false,
    }
    // onProductTourClick = ()=>{
    //   this.setState({ showWalkthrough: true });
    // }
  }

  componentDidMount() {
    this.props.fetchChallengeTypeCount();
    this.getFeaturedChallenge()
    //this.setState({ showWalkthrough: this.props.productTourDetails?.product_tour_data?.admin_challenges });
  }

  getFeaturedChallenge = async () =>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.props;
    try {
      const res = await http.get(`${GetFeaturedChallengesLibrary}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          getFeaturedChallenge:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  redirection = () => {
    const { history } = this.props;
    history.push('/company/challenges/create-activty')
  };

  showPastEvents = (path) => {
    this.props.history.push(path);
  };

  onCloseTab = (value) => {
    this.setState({
      selectedTab: value,
      selectedTabId: value + 1,
    });
    if(value===2){
      this.props.fetWellbeingCategories()
    }
  };

  onHover = (value) => {
    this.setState({
      hoverButton: value
    })
  };

  recommended = [
    { 
      title: "Morning Yoga", 
      id: 1, 
      color: "#E4888C", 
      backgroundColor: "#EFEFEF", 
      description: "Start your day with a refreshing yoga session. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet.", 
      category_name: "wellness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Healthy Eating", 
      id: 2, 
      color: "#88C0E4", 
      backgroundColor: "#F0F8FF", 
      description: "Learn the benefits of a balanced diet. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session.", 
      category_name: "nutrition",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Mindfulness Meditation", 
      id: 3, 
      color: "#A3D9A5", 
      backgroundColor: "#EAFBEA", 
      description: "Practice mindfulness to reduce stress and increase focus. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet", 
      category_name: "mental health",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Strength Training", 
      id: 4, 
      color: "#FFB347", 
      backgroundColor: "#FFF5E1", 
      description: "Build muscle and improve endurance with strength exercises. Practice mindfulness to reduce stress and increase focus. Practice mindfulness to reduce stress and increase focus. Practice mindfulness to reduce stress and increase focus", 
      category_name: "fitness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Hydration Tips", 
      id: 5, 
      color: "#6495ED", 
      backgroundColor: "#E6ECF7", 
      description: "Stay hydrated for better health and performance. Build muscle and improve endurance with strength exercises. Build muscle and improve endurance with strength exercises. Build muscle and improve endurance with strength exercises", 
      category_name: "wellness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    }
  ];

  render() {
    const { history, activityChallengeType, wellbeingCategoriesData, role, t,brandingColor } = this.props;
    const { selectedTab, getFeaturedChallenge } = this.state;
    if (_.isNull(activityChallengeType)|| _.isUndefined(activityChallengeType)) {
      return <Waiting />
    }
    // let getColor = "rgba(243, 122, 101, 1)"

    let getColor = brandingColor ? brandingColor : "rgba(243, 122, 101, 1)"
    return (
      <Layout>
        <ChallengeSnapShotDriver
          activeTabId={this.state.selectedTabId}
          setTab={(tabId) => this.setState({ selectedTabId: tabId })} 
        />

        <Main>
          {
            <BrandingTabContainer isCompare={"0px"}>
              <div className='wrapper'>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={false} onClick={() => this.showPastEvents(history.location.pathname.includes("/company/challenges/")?'/company/challenges':'/challenges')}>
                  Snapshot
                </BrandingTab>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={false} onClick={() => this.showPastEvents(history.location.pathname.includes("/company/challenges/")?'/company/challenges/completed':'/challenges/completed')}>
                  Completed
                </BrandingTab>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={true} >
                  Library
                </BrandingTab>
              </div>
                
              <div className='rightSection'>
                {role=="ADMIN"&&<div className='compare'>
                  <HoverButton
                    title={"Create Challenge"}
                    svgPath={<AddIconBranding/>}
                    activeColor={"#F37A65"}
                    inActiveColor={"#F37A65"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#F37A65"}
                    onClick={selectedTab===1?history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-activty'):() => history.push('/challenges/create-activty'):history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-behavior'):() => history.push('/challenges/create-behavior') }
                    width={"24px"}
                    height={"24px"}
                    fillOpacity={1}
                  />
                </div>}
              </div>
            </BrandingTabContainer>
          }
          <TabWrapper>
            <TabBottomLine id="activitysubtab" active={selectedTab===1} background={getColor} onClick={() => this.onCloseTab(1)}>
              {t("Activity")}
              <BorderBottom active={selectedTab===1} background={getColor} />
            </TabBottomLine>
            <TabBottomLine id="wellnesssubtab" active={selectedTab===2} background={getColor} onClick={() => this.onCloseTab(2)}>
              {t("Wellness")}
              <BorderBottom active={selectedTab===2} background={getColor} />
            </TabBottomLine>
          </TabWrapper>
          {selectedTab===1 && getFeaturedChallenge?.length>0?<RecommendedCard
            RecommendedEventData={getFeaturedChallenge}
            margin="0px"
            isActivity="1"
            history={history}
            RecommendedEventDataLoading={false}
          />:null}
          <Heading isMargin={"0px 0px 20px 0px"}>
            <div className='icon'>
              {AdminCategories("#184A61")}
            </div>
              Explore Categories
          </Heading>
          {selectedTab===1?<ActivityCategory history={history} activityChallengeType={activityChallengeType} role={role}/>:
            <BehaviorCategory history={history} wellbeingCategoriesData={wellbeingCategoriesData.slice(0, 6)} role={role}/>}
        </Main>
      </Layout>
    );
  }
}

ChallengesCategory.propTypes = {
  history: PropTypes.object,
  role: PropTypes.string,
  fetchChallengeTypeCount: PropTypes.func,
  activityChallengeType: PropTypes.array,
  fetWellbeingCategories: PropTypes.func,
  wellbeingCategoriesData: PropTypes.array,
  t: PropTypes.func,
  brandingColor:PropTypes.string,
  companyId:PropTypes.number
  //productTourDetails:PropTypes.object,
};

const mapStateToProps = (state) => ({
  activityChallengeType: state.challenges.activityChallengeType,
  wellbeingCategoriesData: state.adminReports.wellbeingCategoriesData,
  brandingColor:state.wellnessDashboard.brandingColor,
  //productTourDetails: state.profileData.productTourDetails,
})

const mapDispatchToProps = (dispatch) => ({
  fetchChallengeTypeCount: () => dispatch(fetchChallengeTypeCount()),
  fetWellbeingCategories: () => dispatch(fetWellbeingCategories())
})  

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChallengesCategory));
